import Swal from "sweetalert2";
import { color } from "@/common/data";
/**
 * confirmDeleteMsg.
 * @param {options} options - Optional configuration.
 * @param {deleteObject} [options.deleteObject] - Optional.
 */
export function confirmMsg(options) {
  return new Promise((resolve) =>
    resolve(
      Swal.fire({
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: color?.primary,
        cancelButtonColor: color?.danger,
        ...options,
      })
    )
  );
}

export function confirmDeleteMsg({ options, deleteObject }) {
  return new Promise((resolve) => {
    resolve(
      Swal.fire({
        icon: "warning",
        title: "Delete",
        showCancelButton: true,
        confirmButtonColor: color?.primary,
        cancelButtonColor: color?.danger,
        input: "text",
        text: deleteObject
          ? `you are about to delete ${deleteObject}, this can not be undone`
          : `you are about to make a delete, this can not be undone`,
        inputLabel: "Type 'DELETE' to confirm",
        ...options,
      })
    );
  });
}
export function errorMsg(error, attributes) {
  return new Promise((resolve) =>
    resolve(
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
        showCancelButton: true,
        showConfirmButton: false,
        timer: 2000,
        ...attributes,
      })
    )
  );
}
export function successMsg(message, attributes) {
  return new Promise((resolve) =>
    resolve(
      Swal.fire({
        title: "Success!",
        icon: "success",
        text: message,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: color?.primary,
        timer: 2000,
        ...attributes,
      })
    )
  );
}
// export function AjaxModal(message, attributes) {
//   return new Promise((resolve) =>
//     resolve(
//       Swal.fire({
//         title: message,
//         showCancelButton: true,
//         confirmButtonText: "Proceed",
//         showLoaderOnConfirm: true,
//         preConfirm: async (login) => {
//           try {
//             const githubUrl = `
//         https://api.github.com/users/${login}
//       `;
//             const response = await fetch(githubUrl);
//             if (!response.ok) {
//               return Swal.showValidationMessage(`
//           ${JSON.stringify(await response.json())}
//         `);
//             }
//             return response.json();
//           } catch (error) {
//             Swal.showValidationMessage(`
//         Request failed: ${error}
//       `);
//           }
//         },
//         allowOutsideClick: () => !Swal.isLoading(),
//       }).then((result) => {
//         if (result.isConfirmed) {
//           Swal.fire({
//             title: `${result.value.login}'s avatar`,
//             imageUrl: result.value.avatar_url,
//           });
//         }
//       })
//     )
//   );
// }
